module.exports = __webpack_public_path__ + "img/www.apps.apple.com.9a40114a.png";